<ng-template #template>
    <div class="modal-header">
        <h5 class="modal-title">Rifornimento</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div style="margin-bottom: 10px; text-align:center;"><b >viaggio #{{ travelToRefill.id }}</b></div>
        <h6 style="text-align: center;">
            Attenzione! Ricordati di impostare il livello del
            carburante e di scattare le foto prima del rifornimento.
        </h6>
        <div  class="mb-1">
            Liv carburante:
            <rating [max]="5" [(ngModel)]="refill.fuel_level" [customTemplate]="tt"></rating>

            <ng-template #tt let-i="index" let-v="value">
                <button class="btn btn-{{i < v ? 'alert' : 'default'}}">
                    {{i == 0 ? '&#48;' : ''}}
                    {{i == 1 ? '&#188;' : ''}}
                    {{i == 2 ? '&#189;' : ''}}
                    {{i == 3 ? '&#190;' : ''}}
                    {{i == 4 ? '&#49;' : ''}}
                </button>
            </ng-template>
        </div>

        <div class="input-group mb-1">
            <div class="input-group-prepend">
                <span class="input-group-text width59" id="basic-addon1">Lt</span>
            </div>
            <input type="number" min="1" max="999" class="form-control" placeholder="Quantità litri"
                   [(ngModel)]="refill.quantity"
                   aria-label="Quantità litri" aria-describedby="basic-addon1">
        </div>

        <div class="input-group mb-1">
            <div class="input-group-prepend">
                <span class="input-group-text width59" id="basic-addon12">€</span>
            </div>
            <input type="number" min="1" max="999" class="form-control" placeholder="Spesa in euro"
                   [(ngModel)]="refill.amount"
                   aria-label="Spesa in euro" aria-describedby="basic-addon1">
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text width59" id="basic-addon13">Km</span>
            </div>
            <input type="number" min="1" max="999999" class="form-control" placeholder="Kilometri attuali"
                   [(ngModel)]="refill.kilometers"
                   aria-label="Kilometri attuali" aria-describedby="basic-addon1">
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text width59" id="basic-addon15">Data</span>
            </div>
            <input type="text"
                   class="form-control"
                   #dp="bsDatepicker"
                   style="height: auto;"
                   bsDatepicker
                   [bsConfig]="{dateInputFormat: 'D/MM/YYYY', showWeekNumbers: false}"
                   [bsValue]="(refill.made_at)">
            <timepicker [(ngModel)]="refill.made_at" [showMeridian]="false"></timepicker>
        </div>

        <div [hidden]="dom_elements.box_url64" class="mt-5">
            <video #videoBoxElement id="videoBoxElement" style="width:100%;height:310px;" playsinline [hidden]="no_camera">
            </video>
            <button (click)="takePictureBox()" class="btn btn-primary btn-block" [disabled]="no_camera">
                <span class="oi oi-camera-slr"></span> Scatta foto a cruscotto
            </button>
            <div class="custom-file">
                <input type="file" accept="image/*" class="custom-file-input"
                       id="fsLoadImageBox" size="24" (change)="imageBoxLoaded($event)">
                <label class="custom-file-label" for="fsLoadImageBox">Carica foto cruscotto da libreria...</label>
            </div>
        </div >

        <div [hidden]="!dom_elements.box_url64" class="mt-5 mb-5">
            <canvas id="cnvsBox" class="canvas_recive"></canvas>
            <button (click)="deletePicBox()" class="btn btn-primary btn-block">
                <span class="oi oi-circle-x"></span> Scarta foto a cruscotto
            </button>
        </div >

        <div [hidden]="!dom_elements.recive_url64 && !dom_elements.box_url64">
            <div [hidden]="dom_elements.recive_url64">
                <video #videoRecElement id="videoRecElement" style="width:100%;height:310px;" playsinline [hidden]="no_camera">
                </video>
                <button (click)="takePictureRecive()" class="btn btn-primary btn-block" [disabled]="no_camera">
                    <span class="oi oi-camera-slr"></span> Scatta foto a ricevuta
                </button>
                <div class="custom-file">
                    <input type="file" accept="image/*" class="custom-file-input"
                           id="fsLoadImageRec" size="24" (change)="imageRecLoaded($event)">
                    <label class="custom-file-label" for="fsLoadImageRec">Carica foto ricevuta da libreria...</label>
                </div>
            </div >

            <div [hidden]="!dom_elements.recive_url64">
                <canvas id="cnvsRec" class="canvas_recive"></canvas>
                <button (click)="deletePicRecive()" class="btn btn-primary btn-block">
                    <span class="oi oi-circle-x"></span> Scarta foto a ricevuta
                </button>
            </div >
        </div>

    </div><!-- end modal body-->
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="modalRef.hide()">
            Annulla
        </button>
        <!--<button type="button"
            class="btn btn-secondary"
            [disabled]="dom_elements.assign_btn.is_running || travelToCompile.travelStarted()"
            data-dismiss="modal"
            (click)="sendWarrant()">
      {{ dom_elements.assign_btn.is_running ? dom_elements.assign_btn.txt_run :
      dom_elements.assign_btn.txt_not_run}}</button>-->
        <button type="button" class="btn btn-primary" (click)="doRefill()">Rifornimento</button>
    </div>


</ng-template>
